module.exports = __webpack_public_path__ + "becc7c4944e1f8070fc2f1645ebf067c.png";


//////////////////
// WEBPACK FOOTER
// ./app/components/Footer2/Testimonials/fully-promoted.png
// module id = 564
// module chunks = 16